<template>

    <div class="half-circle-spinner" v-if="!type">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
    </div>

    <div class="half-circle-spinner spinner-small" v-else-if="type == 'small'">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
    </div>

    <div class="half-circle-spinner spinner-xsmall" v-else-if="type == 'xsmall'">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
    </div>

    <div class="spinner-inline" v-else-if="type == 'inline'">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
    </div>

    

</template>

<script>    
export default {
    name: 'spinner',
    props:{
        color: [String],
        type: {
            type: [String, Boolean],
            default: false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
.half-circle-spinner, .half-circle-spinner *, .spinner-inline {
    box-sizing: border-box;
}

.half-circle-spinner {
    margin-top: 60px;
    width: 60px;
    height: 60px;
    border-radius: 100%;
    position: relative;
    left: 50%;
    margin-left: -30px;
}

.half-circle-spinner.spinner-small {
    margin-top: 30px;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    position: relative;
    left: 50%;
    margin-left: -15px;
}

.half-circle-spinner.spinner-xsmall {
    margin-top:0;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    position: relative;
    
    margin-top: 15px;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    position: relative;
    margin-left: -10px;
    left: 50%;
}

.spinner-inline {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    position: relative;
}

.half-circle-spinner .circle {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: calc(60px / 10) solid transparent;
}

.half-circle-spinner.spinner-small .circle{
    border: calc(30px / 10) solid transparent;
}
.half-circle-spinner.spinner-xsmall .circle{
    border: calc(20px / 10) solid transparent;
}
    
.half-circle-spinner .circle.circle-1 {
    border-top-color: #48a0ff;
    animation: half-circle-spinner-animation 1s infinite;
}

.half-circle-spinner .circle.circle-2 {
    border-bottom-color: #48a0ff;
    animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
    0% {
        transform: rotate(0deg);

    }
    100%{
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/spinner.vue